import React, { Component } from 'react';
import Modal from './Modal';

class ReminderModal extends Component {
  state = { isVisible: true };

  closeModal = () => {
    this.setState({ isVisible: false });
  };

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { isVisible } = nextProps;
    if (isVisible) this.setState({ isVisible });
  }

  render() {
    const { isVisible } = this.state;

    return (
      <div className="ReminderModal">
        {isVisible && <Modal {...this.props} onDismiss={this.closeModal} />}
      </div>
    );
  }
}

export default ReminderModal;
